import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

const FloatingWhatsApp = () => {
  const { t } = useLanguage();
  const whatsappNumber = "+905488484828";
  const whatsappLink = `https://wa.me/${whatsappNumber.replace(/\+/g, "")}?text=${encodeURIComponent(t("floatingWhatsapp.defaultMessage"))}`;

  return (
    <>
      {/* Floating WhatsApp Button */}
      <motion.a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: "spring", stiffness: 200 }}
        className="fixed bottom-24 md:bottom-6 right-6 z-50 group"
        aria-label="WhatsApp ile iletişime geç"
        data-testid="floating-whatsapp"
      >
        {/* Pulse rings */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" style={{ animationDelay: "0.5s" }} />
        
        {/* Main button */}
        <div className="relative w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center pulse-whatsapp hover:scale-110 transition-transform duration-300">
          <FaWhatsapp size={32} className="text-white" />
        </div>

        {/* Tooltip */}
        <div className="absolute right-20 top-1/2 -translate-y-1/2 px-4 py-2 bg-white text-black text-sm font-medium whitespace-nowrap rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none shadow-lg">
          {t("floatingWhatsapp.tooltip")}
          <span className="absolute right-[-6px] top-1/2 -translate-y-1/2 border-l-8 border-l-white border-y-4 border-y-transparent" />
        </div>
      </motion.a>

      {/* Short Disclaimer - Fixed at bottom */}
      <div className="fixed bottom-0 left-0 right-0 z-40 bg-[#0A0A0A]/95 backdrop-blur-sm border-t border-white/5 py-2 px-4 hidden md:block" data-testid="short-disclaimer">
        <p className="text-center text-gray-500 text-xs max-w-4xl mx-auto leading-relaxed">
          {t("legal.shortDisclaimer")}
        </p>
      </div>
    </>
  );
};

export default FloatingWhatsApp;
